import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { ReactNode } from "react";

export type FaqBlockData = {
  title: string;
  description: string;
  items: {
    question: string;
    answer: ReactNode;
  }[];
};

import { ComponentPropsWithoutRef, FC } from "react";
import Typography from "../Typography";

type FaqBlockProps = {
  data: FaqBlockData;
} & ComponentPropsWithoutRef<"section">;

const FaqBlock: FC<FaqBlockProps> = ({ data, ...rest }) => {
  return (
    <section {...rest} className={`${rest.className} mx-auto my-32 md:my-64`}>
      <Typography className="text-center" variant="h2">
        {data.title}
      </Typography>
      <div className="mt-16 font-display w-full flex flex-col text-left items-stretch justify-start gap-12">
        {data.items.map((faq) => {
          return (
            <details
              key={faq.question}
              className=" font-light list-none group open:bg-slate-100 rounded-2xl"
            >
              <summary className="text-xl font-normal list-none flex items-center justify-stretch hover:bg-slate-100 p-4 rounded-2xl cursor-pointer">
                <Typography className="text-slate-900" variant="subtitle1">
                  {faq.question}
                </Typography>
                <ChevronDownIcon className="w-6 h-6 ml-auto group-open:rotate-180 shrink-0 text-slate-500" />
              </summary>
              <div className="px-4 pb-4">
                <Typography variant="body2" className="text-slate-600">
                  {faq.answer}
                </Typography>
              </div>
            </details>
          );
        })}
      </div>
    </section>
  );
};

export default FaqBlock;
